import { render, staticRenderFns } from "./IslykillMock.vue?vue&type=template&id=d2ae1016&"
import script from "./IslykillMock.vue?vue&type=script&lang=js&"
export * from "./IslykillMock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports